<template>
  <PrimaryModal @clickBackground="close()">
    <div class="p-4">
      <h2 class="text-2xl p-4">{{ $t('message.login') }}</h2>
      <div
        v-if="hasError"
        class="border p-2 mb-2 rounded text-red-600 border-red-400 bg-red-100 dark:text-dark-text dark:border-red-900 dark:bg-red-900"
      >
        {{ $t('message.loginFailed') }}
      </div>
      <div style="width: 30vw">
        <div class="mb-4">
          <label class="text-sm ml-1" for="id"> ID </label>
          <input
            v-model="id"
            class="mt-1"
            :class="isLightMode() ? 'input' : 'input-dark'"
            placeholder="Account ID"
            required
            type="text"
          />
        </div>
        <div>
          <label class="text-sm ml-1" for="password">
            {{ $t('message.password') }}
          </label>
          <input
            v-model="password"
            class="mt-1 focus:outline-none"
            :class="isLightMode() ? 'input' : 'input-dark'"
            placeholder="**********"
            required
            type="password"
          />
        </div>
        <div class="flex justify-center mt-8">
          <IconTextButton
            :border_radius="2"
            class="mx-1"
            :font_weight="'700'"
            :icon="'person_add'"
            :iconSize="'text-xl'"
            :padding_bottom="4"
            :padding_left="10"
            :padding_right="10"
            :padding_top="4"
            :text="$t('message.createNewAccount')"
            :textSize="'text-base'"
            @click="onClickCreateAccount"
          />
          <IconTextButton
            :border_radius="2"
            class="mx-1"
            :font_weight="'700'"
            :icon="'login'"
            :iconSize="'text-xl'"
            :padding_bottom="4"
            :padding_left="10"
            :padding_right="10"
            :padding_top="4"
            :text="$t('message.login')"
            :textSize="'text-base'"
            @click="onClickLogin"
          />
        </div>
      </div>
    </div>
  </PrimaryModal>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

import IconTextButton from '@/presentation/components/Button/IconTextButton.vue'
import PrimaryModal from '@/presentation/components/Modal/PrimaryModal.vue'
import { useAuthStatePresenter } from '@/presentation/composables/auth/useAuthStatePresenter'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useModalStatePresenter } from '@/presentation/composables/modal/useModalStatePresenter'

export default defineComponent({
  components: { PrimaryModal, IconTextButton },
  setup(props, ctx) {
    const id = ref<string>('')
    const password = ref<string>('')
    const hasError = ref<boolean>(false)

    const { login, isLogin } = useAuthStatePresenter()
    const { isLightMode } = useConfigStatePresenter()
    const { setIsShowLoginModal, setIsShowUserRegistrationModal } = useModalStatePresenter()

    const onClickLogin = async () => {
      const success = await login(id.value, password.value)
      hasError.value = !success
    }

    const onClickCreateAccount = () => {
      setIsShowLoginModal(false)
      setIsShowUserRegistrationModal(true)
    }

    const close = () => {
      setIsShowLoginModal(false)
    }

    return { id, password, hasError, isLightMode, onClickLogin, onClickCreateAccount, close }
  }
})
</script>

<style lang="postcss" scoped>
.input {
  @apply shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight;
  &:focus {
    @apply outline-none;
  }
}
.input-dark {
  @apply shadow appearance-none border-2 rounded w-full py-2 px-3 text-dark-text border-dark-400 leading-tight bg-dark-100;
  &:focus {
    @apply outline-none;
  }
}
</style>
